import type { FormikContextType } from 'formik';
import { useFormik } from 'formik';
import _ from 'lodash';
import * as Yup from 'yup';
import { Alert, Store, store } from '../../store';

interface Values {
  email: string;
  code: string;
  password: string;
  passwordConfirm: string;
}

interface Form {
  formik: FormikContextType<Values>;
  loading: boolean;
  alert: Alert;
}

const validationSchema = Yup.object({
  code: Yup.string().trim().required('Please enter a confirmation code.'),
  password: Yup.string().trim().required('A valid password is required.'),
  passwordConfirm: Yup.string().oneOf([Yup.ref('password'), undefined], 'Passwords must match')
});

export const useForm = (): Form => {
  const [confirmForgotPassword, { loading, error }] = Store.User.useConfirmForgotPassword();
  const { awsCognitoUser } = store.getState();
  const alert = Alert.useAlert(error);

  const formik = useFormik<Values>({
    initialValues: {
      email: awsCognitoUser?.getUsername() ?? '',
      code: '',
      password: '',
      passwordConfirm: ''
    },

    validationSchema,
    validateOnMount: true,

    validate(): void {
      alert.hide();
    },

    onSubmit(data: Values): void {
      alert.hide();

      if (!loading) {
        // Execute the mutation
        confirmForgotPassword(_.omit(data, 'passwordConfirm'));
      }
    }
  });

  return {
    formik,
    loading,
    alert
  };
};
